import i18nTranslator from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationEN from './translations/en/translation.json';
import translationES from './translations/es/translation.json';
import translationFR from './translations/fr/translation.json';
import translationTH from './translations/th/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
  es: {
    translation: translationES,
  },
  th: {
    translation: translationTH,
  },
};

i18nTranslator
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['cookie'],
      lookupCookie: 'lang',
    },
  });

export default i18nTranslator;
